import { render, staticRenderFns } from "./MessageHistoryReplyList.vue?vue&type=template&id=090757d2&scoped=true&lang=pug"
import script from "./MessageHistoryReplyList.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryReplyList.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryReplyList.vue?vue&type=style&index=0&id=090757d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090757d2",
  null
  
)

export default component.exports